<script lang="ts">
  import i18n from '../../i18n'
  import ProjectsList from './ProjectsList.svelte'
  import Button from '../../components/button/Button.svelte'
  import { createProject } from '../../api/projects'
  import { goto } from '@mateothegreat/svelte5-router'
  import { createMutation } from '@tanstack/svelte-query'
  import { usePageTitle } from '../../hooks/page-title'
  import DefaultLayout from '../../components/default-layout/DefaultLayout.svelte'
  import { navbarSearchQuery } from '../../stores/navbar-search'
  import queryClient from '../../constants/query-client'

  const { route } = $props()

  usePageTitle($i18n.t('projects.metaTitle'))

  const mutation = createMutation(
    () => ({
      mutationFn: () => {
        return createProject('Untitled')
      },
      onSuccess: (data) => {
        goto(`/projects/${data.data.id}`)
      },
    }),
    () => queryClient,
  )

  $effect(() => {
    navbarSearchQuery.set(route.result.querystring.params.q)
  })
</script>

<DefaultLayout>
  <div class="head">
    <h1>{$i18n.t('projects.title')}</h1>
    <Button
      data-testid="new-project"
      disabled={mutation.isPending}
      onclick={() => mutation.mutate()}
      size="sm"
    >
      {$i18n.t('projects.new')}
    </Button>
  </div>
  <ProjectsList />
</DefaultLayout>

<style lang="scss">
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-weight: 800;
      font-size: 1.75rem;
      line-height: 150%;
    }
  }
</style>
